import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const FooterContainer = styled.div`
  margin: 16px;
  margin-top: 0;
  padding-top: 10px;
  border-top: 1px solid #ccc;
  position: sticky;
  z-index: 1;
  bottom: 0;
  background: ${colors.white};
`
export const CloseIcon = styled.img`
  cursor: pointer;
`
